import React from "react";
import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_WARNING
} from "react-redux-notify";

export const getSuccessNotificationMessage = (message) => {
  return {
    message: message,
    type: NOTIFICATION_TYPE_SUCCESS,
    duration: 5000,
    canDismiss: true,
    icon: <i className="fas fa-check" />,
    showCloseAllBtn: false,
  };
};

export const getErrorNotificationMessage = (message) => {
  return {
    message: message,
    type: NOTIFICATION_TYPE_ERROR,
    duration: 7000,
    canDismiss: true,
    icon: <i className="fas fa-check" />,
    showCloseAllBtn: false,
   
  };
};

export const getWarningNotificationMessage = (message) => {
  return {
    message: message,
    type: NOTIFICATION_TYPE_WARNING,
    duration: 7000,
    canDismiss: true,
    icon: <i className="fas fa-check" />,
    showCloseAllBtn: false,
  };
};
